const holidaysData = (state = null, action) => {
  if (action.type === "SET_HOLIDAYS_DATA") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_HOLIDAYS_DATA": {
  //     return action.payload;
  //   }
  //   default: {
  //     return state;
  //   }
  // }
};

export default holidaysData;
